import { PdfRewardsByAcademicYearList } from 'components/pdfStudent';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetSportRewards } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { sportRewardsSelector } from '../../../selectors';
import PdfCommonDataEntityContainer from '../dataEntityContainers/common';
import { splitRewardsByAcademicYear } from '../utils/splitRewardsByAcademicYear';

const PdfSportRewardContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const sportRewards = useAppSelector(sportRewardsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().sportRewards });

  const hasData = sportRewards.content.length > 0;

  const academicYearData = splitRewardsByAcademicYear(sportRewards, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Награды" Icon={IconWidgetSportRewards}>
      {hasData && <PdfRewardsByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfSportRewardContainer;
